import type { Ref, SVGProps } from "react"
import { forwardRef, memo } from "react"

interface SVGRProps {
    title?: string
    titleId?: string
}
const SvgRecordStopPrivate = (
    { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
    ref: Ref<SVGSVGElement>,
) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        role="img"
        ref={ref}
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <circle cx={12} cy={12} r={12} fill="#fff" />
        <rect width={8} height={8} x={8} y={8} fill="#C60101" rx={1} />
    </svg>
)
const ForwardRef = forwardRef(SvgRecordStopPrivate)
const Memo = memo(ForwardRef)
export default Memo
